import React from 'react';

interface LogoProps {
  light?: boolean;
  className?: string;
  showTagline?: boolean;
  compact?: boolean;
  size?: 'sm' | 'md' | 'lg' | 'xl';
}

export const CameroonLogo: React.FC<LogoProps> = ({
  light = false,
  className = '',
  compact = false,
  size = 'md',
}) => {
  const [imgError, setImgError] = React.useState(false);

  const heightClass =
    size === 'sm'
      ? 'h-8 sm:h-9'
      : size === 'lg'
      ? 'h-16 sm:h-20'
      : size === 'xl'
      ? 'h-20 sm:h-24'
      : compact
      ? 'h-9 sm:h-10'
      : 'h-11 sm:h-12 md:h-14';

  if (imgError) {
    return (
      <div className={`inline-flex items-center gap-2 select-none cursor-pointer ${className}`}>
        <div className="w-10 h-10 rounded-xl bg-gradient-to-tr from-[#094426] to-[#0d5c34] flex items-center justify-center shadow-md border border-amber-400/40 text-amber-400 font-black text-sm">
          CLM
        </div>
        <div className="flex flex-col leading-tight">
          <span className="font-extrabold text-[#094426] tracking-tight text-sm uppercase">Cameroon Land</span>
          <span className="font-bold text-amber-600 text-xs tracking-wider">MARKET</span>
        </div>
      </div>
    );
  }

  return (
    <div
      className={`group inline-flex items-center select-none cursor-pointer transition-transform duration-200 active:scale-95 ${className}`}
    >
      <picture>
        <source srcSet="/cameroon-land-market-logo.webp" type="image/webp" />
        <img
          src="/cameroon-land-market-logo.png"
          alt="Cameroon Land Market"
          width="160"
          height="48"
          decoding="async"
          onError={() => setImgError(true)}
          className={`${heightClass} w-auto object-contain transition-transform duration-200 group-hover:scale-[1.03]`}
        />
      </picture>
    </div>
  );
};


